<template>
  <div class="separator">
    <div :class="titleWrapperClasses" v-if="title">
      <span :class="titleClasses">
        <span v-if="icon" class="separator__number">
          <m4-icon :icon="icon"></m4-icon>
        </span>
        <span v-if="number" class="separator__number">
          {{ number }}
        </span>
        {{ title }}
      </span>
    </div>
    <hr :class="borderClasses" />
  </div>
</template>

<script>
export default {
  name: "M4Separator",
  props: {
    number: [Number, String],
    icon: String,
    title: [Number, String],
    titleBgLight: Boolean,
    titleBgFrontend: Boolean,
    titleDarken: Boolean,
    titleDark: Boolean,
    titleBolder: Boolean,
    borderDarken: Boolean,
    onBlackBg: Boolean,
    titleAlign: {
      type: String,
      default() {
        return "center";
      }
    },
    borderStyle: {
      type: String,
      default() {
        return "solid";
      }
    }
  },
  computed: {
    titleClasses() {
      let classes = ["separator__center__title"];
      if (this.titleBgLight) {
        classes.push("separator__center__title--light-bg");
      }
      if (this.titleBgFrontend) {
        classes.push("separator__center__title--frontend-bg");
      }
      if (this.titleDarken) {
        classes.push("separator__center__title--darken");
      }
      if (this.titleDark) {
        classes.push("separator__center__title--dark");
      }
      if (this.titleBolder) {
        classes.push("separator__center__title--bolder");
      }
      if (this.titleAlign) {
        classes.push("separator__center__title--center");
      }
      if (this.onBlackBg) {
        classes.push("separator__center__title--black-bg");
      }
      return classes;
    },
    titleWrapperClasses() {
      let classes = ["separator__center"];
      if (this.titleAlign) {
        classes.push("separator__center--" + this.titleAlign);
      }

      return classes;
    },
    borderClasses() {
      let classes = ["separator__border"];
      if (this.borderStyle) {
        classes.push("separator__border--" + this.borderStyle);
      }
      if (this.borderDarken) {
        classes.push("separator__border--darken");
      }
      return classes;
    },
    numberAttrIsString() {
      return typeof this.number === "string";
    }
  }
};
</script>
